import URLParamService from "./URLParamService";
import { hasOwn } from "@/utils/object";

const queryParams = URLParamService.getQueryParams();
const apiKey = queryParams.apiKey;
const hash = queryParams.hash;
const ts = queryParams.ts;
const token = queryParams.token;

const getApiKey = (): string => {
  if (hasOwn(queryParams, "apiKey") && apiKey?.length > 0) {
    return apiKey;
  }
  return "";
};

const getHash = (): string => {
  if (hasOwn(queryParams, "hash") && hash?.length > 0) {
    return hash;
  }
  return "";
};

const getTs = (): number => {
  if (hasOwn(queryParams, "ts") && ts) {
    return ts;
  }
  return Math.floor(new Date().getTime() / 1000);
};

const getToken = (): string => {
  if (hasOwn(queryParams, "token") && token?.length > 0) {
    return token;
  }
  return "";
};

const AuthService = {
  getApiKey,
  getHash,
  getTs,
  getToken,
};

export default AuthService;
